import { Button, Link } from '@huntington/honeycomb';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LOGIN } from '../../../../router/router';
import {
	CIRCADIA_HELP_EMAIL,
	EXPIRED_LINK_ERROR_MESSAGE,
	EXPIRED_LINK_HEADER,
	EXPIRED_OK_BUTTON,
} from '../../../../constants/messages';

export default function ExpiredPage() {
	const navigate = useNavigate();

	const handleSubmit = () => {
		navigate(ROUTE_LOGIN);
	};
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1.5rem' }}>
			<Typography
				variant="h1"
				gutterBottom
				sx={{
					fontFamily: '"Huntington Serif", serif',
					fontSize: '2.25rem',
					fontWeight: '700',
					marginBottom: '1rem',
				}}
			>
				{EXPIRED_LINK_HEADER}
			</Typography>

			<Box>
				<Typography gutterBottom>{EXPIRED_LINK_ERROR_MESSAGE}</Typography>
				<Link href={`mailto:${CIRCADIA_HELP_EMAIL}`}>{CIRCADIA_HELP_EMAIL}</Link>
			</Box>

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'center',
					marginTop: '1.5rem',
					alignSelf: 'stretch',
				}}
			>
				<Button onClick={handleSubmit}>{EXPIRED_OK_BUTTON}</Button>
			</Box>
		</Box>
	);
}
